import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../core/okta-auth.guard';
import { OpsVendorManagementComponent } from './ops-vendor-management.component';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldCardModule } from '@emerald-angular/card';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { OnboardVendorComponent } from './onboard-vendor/onboard-vendor.component';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { OpsVendorsListComponent } from './ops-vendors-list/ops-vendors-list.component';
import { OpsTopVendorsComponent } from './ops-top-vendors/ops-top-vendors.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { NgChartsModule } from 'ng2-charts';
import { Chart } from 'chart.js';
import { InviteFormComponent } from './invite-form/invite-form.component';
import { OpsModule } from '../ops-team/ops.module';
import { VendorsListComponent } from './vendors-list/vendors-list.component';
import { OpsContractorHeadCountComponent } from './ops-contractor-head-count/ops-contractor-head-count.component';
import { OpsTimesheetComponent } from './ops-timesheet/ops-timesheet.component';
import { TimesheetCalendarComponent } from './ops-timesheet-calendar/ops-timesheet-calendar.component';
import { EmeraldPaginationModule } from '@emerald-angular/pagination';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldProgressIndicatorModule } from '@emerald-angular/progress-indicator';
import { EmeraldMenuModule } from '@emerald-angular/menu';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';
import { MsaExpiryComponent } from './msa-expiry/msa-expiry.component';
import { OpsTimesheetTrendsComponent } from './ops-timesheet-trends/ops-timesheet-trends.component';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { EmeraldSwitchModule } from '@emerald-angular/switch';
import { AccessControlPageComponent } from './access-control/access-control-page/access-control-page.component';
import { AddVendorPocComponent } from './access-control/add-vendor-poc/add-vendor-poc.component';
import { QuarterlyFeedbackFormComponent } from './quarterly-feedback-form/quarterly-feedback-form.component';
import { OpsContractorProfileComponent } from './ops-contractor-profile/ops-contractor-profile.component';
import { OpsContractorsListComponent } from './ops-contractors-list/ops-contractors-list.component';
import { OpsContractorsListFilterComponent } from '@app/shared/modals/ops-contractors-list-filter/ops-contractors-list-filter.component';
import { ContractorVendorHeadCountComponent } from './vendor-profile-page/app-contractor-vendor-head-count/app-contractor-vendor-head-count.component';
import { InterviewsStatusComponent } from './vendor-profile-page/interviews-status/interviews-status.component';
import { QuarterlyFeedbackComponent } from './vendor-profile-page/quarterly-feedback/quarterly-feedback.component';
import { QuaterlyFeedbackComponent } from '@shared/components/quaterly-feedback/quaterly-feedback.component';
import { RtoBarChartComponent } from './vendor-profile-page/quarterly-feedback/rto-bar-chart/rto-bar-chart.component';
import { VendorInfoComponent } from './vendor-profile-page/vendor-info/vendor-info.component';
import { VendorProfileComponent } from './vendor-profile-page/vendor-profile-page.component';
import { VendorManagementModule } from '@pages/vendor-management/vendor-management.module';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { SharedModule } from '@app/shared/shared.module';
import { EmployeeDetailsComponent } from '@app/shared/components/employee-details/employee-details.component';
Chart.register(ChartDataLabels);

const routes: Routes = [
  {
    path: 'ops-vendor-management',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: '', component: OpsVendorManagementComponent },
          { path: 'invite-vendor', component: InviteFormComponent },
          { path: 'onboard-vendor', component: OnboardVendorComponent },
          { path: 'all-vendors', component: OpsVendorsListComponent },
          { path: 'vendors-list', component: VendorsListComponent },
          { path: 'vendors-profile/:vendorId/:vendorName', component: VendorProfileComponent },
          { path: 'timesheet', component: OpsTimesheetComponent },
          { path: 'quarterly-feedback', component: QuaterlyFeedbackComponent },
          { path: 'quarterly-feedback/:vendorId', component: QuarterlyFeedbackFormComponent },
          { path: 'access-control', component: AccessControlPageComponent },
          { path: 'contractor-profile/:id', component: OpsContractorProfileComponent },
          { path: 'contractors-list', component: OpsContractorsListComponent },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    EmeraldDesignSystemModule,
    EmeraldButtonModule,
    EmeraldDropdownModule,
    EmeraldCardModule,
    EmeraldIconModule,
    EmeraldTabBarModule,
    FormsModule,
    ChartModule,
    OpsModule,
    ReactiveFormsModule,
    EmeraldPaginationModule,
    EmeraldInputModule,
    FormsModule,
    EmeraldProgressIndicatorModule,
    EmeraldMenuModule,
    EmeraldDatepickerModule,
    ReactiveFormsModule,
    FileUploadComponent,
    EmeraldSwitchModule,
    NgChartsModule,
    TimesheetCalendarComponent,
    VendorManagementModule,
    ModalWrapperComponent,
    ConfirmationDialogComponent,
    EmployeeDetailsComponent,
  ],
  declarations: [
    OpsVendorManagementComponent,
    OnboardVendorComponent,
    OpsVendorsListComponent,
    OpsTopVendorsComponent,
    VendorsListComponent,
    InviteFormComponent,
    OpsContractorHeadCountComponent,
    OpsTimesheetComponent,
    MsaExpiryComponent,
    OpsTimesheetTrendsComponent,
    QuarterlyFeedbackFormComponent,
    OpsContractorsListComponent,
    OpsContractorsListFilterComponent,
    OpsContractorProfileComponent,
    AccessControlPageComponent,
    AddVendorPocComponent,
    ContractorVendorHeadCountComponent,
    InterviewsStatusComponent,
    QuarterlyFeedbackComponent,
    RtoBarChartComponent,
    VendorInfoComponent,
    VendorProfileComponent,
    QuaterlyFeedbackComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [RouterModule],
})
export class OpsVendorManagementModule {}